import { FormContextValues, useFormController } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../translations';

export type VisitReopenFormBean = {
   reason: string | null;
};

export type VisitReopenFormController = FormContextValues<VisitReopenFormBean>;

type VisitReopenFormRenderer = (
   renderProps: Pick<VisitReopenFormController, 'handleSubmit' | 'formState'>
) => JSX.Element;

type VisitReopenFormProps = {
   readonly children: VisitReopenFormRenderer;
};

export const VisitReopenForm = (props: VisitReopenFormProps): JSX.Element => {
   const { handleSubmit, register, formState } = useFormController<VisitReopenFormBean>({
      reason: null,
   });

   return (
      <form noValidate>
         <Textarea
            testId={'reason'}
            label={appointmentsTranslationKeys.reopenVisitModal.reason}
            controller={register('reason', { required: true })}
            placeholder={appointmentsTranslationKeys.reopenVisitModal.enterReason}
            maxLength={200}
            rows={4}
            maxRows={4}
         />

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </form>
   );
};
